/** Whether the router serves this real path under one of its templates, a `$param` segment standing for any one segment. */
export function matchesRouteTemplate(templates: ReadonlySet<string>, path: string): boolean {
  if (templates.has(path)) return true;
  const segments = path.split('/');
  for (const template of templates) {
    const templateSegments = template.split('/');
    if (
      templateSegments.length === segments.length &&
      templateSegments.every((part, index) =>
        part.startsWith('$') ? segments[index] !== '' : part === segments[index],
      )
    ) {
      return true;
    }
  }
  return false;
}
